/**
 * @enum enumPersistableObjectType provides an enumeration of class types that are
 * persistable.
 * (Note: Try to keep the enumerations in alphabetical order to simplify viewing.)
 */
export enum enumNoParentObjectType {
  NoParent = '',
}
